import type { ReactNode } from 'react'
import { Icon, type IconName } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'

type EmptyStateProps = {
  title: string
  description: string
  icon?: IconName
  action?: ReactNode
  className?: string
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-lg border border-border bg-surface-sunken px-6 py-10 text-center',
        className,
      )}
    >
      {icon ? (
        <span className="inline-flex size-control-md items-center justify-center rounded-full bg-accent-surface text-accent-text">
          <Icon name={icon} className="size-6" />
        </span>
      ) : null}

      <h3 className="text-base font-semibold text-ink">{title}</h3>
      <p className="max-w-prose text-sm text-ink-muted">{description}</p>

      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  )
}
